

import React from 'react';

import styled from 'styled-components';








const DividerBase = styled.div.attrs(
  (props) => ({
    style: { ...props.style }
  }))`${(props) => props.computedStyle}`;

const Divider = (props) => {
  const { divider, style, computedStyle } = props;
  const { html = '' } = divider;
  if (html) {
    return html;
  }

  return (
    <DividerBase
      style={style}
      computedStyle={computedStyle} />);


};

export default Divider;